import { render, staticRenderFns } from "./ColorDelete.vue?vue&type=template&id=f4576c56&scoped=true&"
import script from "./ColorDelete.vue?vue&type=script&lang=js&"
export * from "./ColorDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4576c56",
  null
  
)

export default component.exports